module.exports = __webpack_public_path__ + "img/wallet-coins.8c14b93.webp";